import AbstractService from './AbstractService';

export default class StructureService extends AbstractService {
  url(url) {
    return `/structures${url}`;
  }

}
